export default {
  login: {
    title: 'Secure Access',
    subtitle: 'Log in to your cockpit',
    emailLabel: 'Email Identifier',
    emailPlaceholder: 'your@ekose.rx',
    passwordLabel: 'Access Key',
    passwordPlaceholder: '••••••••',
    forgotPassword: 'Forgot?',
    submitButton: 'Authentication',
    lockedButton: 'Restricted Access',
    orContinueWith: 'Or continue with',
    noAccount: 'No cockpit yet?',
    createAccount: 'Create an account',
    biometricReady: 'Biometric Ready',
    hdsCompliant: 'HDS Compliant',
    brand: 'EKOSE',
    tagline: 'High Performance Medical Platform',
    errors: {
      unrecognized: 'Credentials not recognized. {{count}} attempt(s) before lockout.',
      lockout: 'Security: Lockout protocol active. Try again in {{count}} minute(s).',
      lockoutImmediate: 'Too many attempts. Account locked for 5 minutes.',
      authContextMissing: 'Authentication context is unavailable.',
      tooManyAttempts: 'Too many attempts. Try again in {{count}} minute(s).',
      unknownError: 'An unexpected error occurred. Please try again.'
    },
    emailRequired: "Email is required.",
    emailInvalid: "Invalid email format.",
    passwordRequired: "Password is required.",
    passwordTooShort: "Password must be at least 6 characters.",
    platformSubtitle: "Medical teleconsultation platform",
    personalSpaceSubtitle: "Access your personal space",
    rememberMe: "Remember me",
    forgotPasswordFull: "Forgot password?",
    connecting: "Connecting...",
    sessionDurationInfo: "Your session will be maintained for 30 days",
    testAccountsTitle: "Test accounts:",
    testDoctor: "👨‍⚕️ Doctor: dr.martin@ekose.com / password123",
    testAdmin: "🏥 Admin: admin@ekose.com / password123",
    testPatient: "👤 Patient: patient1@ekose.com / password123"
  },
  register: {
    title: 'Join Us',
    brand: 'Ekose.Rx',
    subtitle: 'Initializing your health profile',
    roleLabel: 'Choose your access',
    roles: {
      patient: 'Patient',
      patientDesc: 'Care & Follow-up',
      doctor: 'Practitioner',
      doctorDesc: 'Expertise & Offices'
    },
    nameLabel: 'Full Name',
    namePlaceholder: 'John Doe',
    emailLabel: 'Email Address',
    emailPlaceholder: 'your@ekose.rx',
    passwordLabel: 'Access Key',
    passwordPlaceholder: '••••••••',
    submitButton: 'Start Onboarding',
    orContinueWith: 'Or continue with',
    alreadyMember: 'Already an elite member?',
    loginLink: 'Log in',
    hdsSecured: 'HDS Secured',
    privacyFirst: 'Privacy First',
    activePulse: 'Active Pulse',
    dateOfBirthLabel: 'Date of Birth (Patients)',
    genderLabel: 'Gender (Patients)',
    genderPlaceholder: 'Select gender...',
    genders: {
      male: 'Male',
      female: 'Female',
      other: 'Other'
    },
    errors: {
      authContextMissing: 'Authentication context is unavailable.',
      formErrors: 'Please correct errors in the form',
      emailTaken: 'This email is already in use',
      unknownError: 'An unexpected error occurred during account creation.'
    }
  },
  mfa: {
    setupTitle: "Secure your account",
    setupSubtitle: "Enable two-factor authentication",
    setupInstructions: "Scan this QR code with your authenticator application",
    qrCodePlaceholder: "Displaying QR Code requires installing qrcode.react.",
    backupCodesTitle: "Backup codes",
    backupCodesInstructions: "Store these codes in a safe place. You will need them if you lose your phone.",
    show: "Show",
    hide: "Hide",
    copy: "Copy",
    copied: "Copied",
    download: "Download",
    cancel: "Cancel",
    continue: "Continue",
    verifyTitle: "Verification",
    verifySubtitle: "Enter the code from your authenticator application",
    verificationCodeLabel: "Verification code",
    verificationCodePlaceholder: "000000",
    verifyBtn: "Verify",
    verifying: "Verifying...",
    useBackupCode: "Use a backup code",
    backupCodeLabel: "Backup code",
    backupCodePlaceholder: "Enter backup code",
    useBackupCodeBtn: "Use backup code",
    completeTitle: "MFA Enabled!",
    completeSubtitle: "Your account is now secured with two-factor authentication.",
    finishBtn: "Finish",
    initializingToast: "MFA Setup initialized",
    initErrorToast: "Error initializing MFA setup",
    enterCodeToast: "Please enter the verification code",
    successToast: "MFA successfully enabled!",
    incorrectCodeToast: "Incorrect verification code",
    verificationErrorToast: "Error verifying MFA token",
    enterBackupCodeToast: "Please enter a backup code",
    incorrectBackupCodeToast: "Incorrect backup code",
    backupCodeErrorToast: "Error verifying backup code",
    codesCopiedToast: "Backup codes copied",
    codesDownloadedToast: "Backup codes downloaded",
    loadingText: "Configuring multi-factor authentication..."
  },
  verification: {
    loading: "Verifying authentication...",
    roleMissing: "Role missing - redirecting to login",
    unauthorized: "Access denied - insufficient role",
    unauthorizedPermissions: "Access denied - insufficient permissions",
    missingRoleLog: "Missing user role"
  }
};
